// src/utils/storeNavigation.js
import { store } from "../shared";
import { setModesModal } from "../shared/slice/ModalMode/ModalMode";
import { setScroll } from "../shared/slice/scroll/ScrollSlice";
import { setOrder } from "../shared/slice/order/OrderSlice";
import { resetPromo } from "../shared/slice/promos/PromosSlice";
import { setStoresModal } from "../shared/slice/ModalStores/ModalStores";
import {
  setRestaurantSelected,
  setMode,
  setModeSelectedId,
  setModeName,
  setProduct,
} from "../shared/slice/restaurant/RestaurantSlice";
import {
  getProductByStoreByMode,
  getStoreById,
  getStoreID,
} from "../shared/slice/restaurant/RestaurantService";

export const getCurrentSlug = () => {
  const hostname = window.location.hostname;
  const pathname = window.location.pathname;

  console.log("🔍 getCurrentSlug - hostname:", hostname, "pathname:", pathname);

  // Handle production URL (dev-market.eatorder.fr/slug)
  if (
    hostname === "dev-market.eatorder.fr" ||
    hostname === "market.eatorder.fr"
  ) {
    const pathParts = pathname.split("/").filter(Boolean);
    const slug = pathParts.length > 0 ? pathParts[0] : null;
    console.log("🌐 Production slug detected:", slug);
    return slug;
  }

  // Handle local development (localhost:3000/slug)
  if (hostname === "localhost" || hostname.includes("localhost")) {
    const slug = pathname.split("/")[1] || null;
    console.log("🏠 Localhost slug detected:", slug);
    return slug;
  }

  // Handle subdomains (slug-dev.eatorder.fr)
  if (hostname.includes("-dev.eatorder.fr")) {
    const slug = hostname.split("-dev.eatorder.fr")[0];
    console.log("🌐 Subdomain slug detected:", slug);
    return slug;
  }

  console.log("❌ No slug detected");
  return null;
};
export const initializeStore = async (slug) => {
  console.log('🏪 Initializing store with slug:', slug);
  const effectiveSlug = slug || getCurrentSlug();
  
  if (!effectiveSlug) {
    console.error('❌ No slug found, redirecting to home');
    window.location.href = 'https://dev-market.eatorder.fr';
    return false;
  }

  console.log('✅ Effective slug:', effectiveSlug);
  
  try {
    // 1. Reset initial state
    store.dispatch(setOrder({ order: [] }));
    store.dispatch(resetPromo());
    
    // 2. Get store data using slug
    console.log('🔄 Fetching restaurant data for slug:', effectiveSlug);
    const storeResponse = await getStoreID(effectiveSlug);
    
    if (!storeResponse || !storeResponse.data) {
      console.error('❌ Invalid store response');
      return false;
    }

    const storeData = storeResponse.data;
    const storeId = storeData._id;
    
    if (!storeId) {
      console.error('❌ Store ID not found in response');
      return false;
    }

    // 3. Get full restaurant data
    const restaurantData = await getStoreById(storeId);
    
    if (!restaurantData || !restaurantData.data) {
      console.error('❌ Restaurant not found for slug:', effectiveSlug);
      return false;
    }

    const fullRestaurantData = restaurantData.data;
    console.log('✅ Restaurant data loaded:', fullRestaurantData);
    
    // 4. Set restaurant data and disable store selection modal
    store.dispatch(setRestaurantSelected({ restaurantSelected: fullRestaurantData }));
    store.dispatch(setStoresModal({ storesModal: false })); // Disable store selection modal
    
    // 5. Handle modes
    if (fullRestaurantData.mode && fullRestaurantData.mode.length > 0) {
      store.dispatch(setMode({ mode: fullRestaurantData.mode }));
      console.log('✅ Restaurant modes loaded:', fullRestaurantData.mode);
    }
    
    // 6. Check for URL mode parameter
    const urlParams = new URLSearchParams(window.location.search);
    const modeParam = urlParams.get("mode");
    
    if (modeParam && fullRestaurantData.mode) {
      console.log('🎯 Mode requested from URL:', modeParam);
      
      const normalize = str => str.replace(/[\s\-_]/g, '').toLowerCase();
      const foundMode = fullRestaurantData.mode.find(
        (modeObj) => modeObj.mode && 
        typeof modeObj.mode.name === "string" && 
        normalize(modeObj.mode.name) === normalize(modeParam)
      );
      
      if (foundMode) {
        console.log('✅ Mode found:', foundMode.mode.name);
        
        store.dispatch(setModeSelectedId({ modeSelectedId: foundMode.mode._id }));
        store.dispatch(setModeName({ modeName: foundMode.mode.name }));
        
        // Load products for this mode
        console.log('🔄 Loading products for mode:', foundMode.mode._id);
        const productsResponse = await getProductByStoreByMode(storeId, foundMode.mode._id);
        
        if (productsResponse && productsResponse.data) {
          store.dispatch(setProduct({ product: productsResponse.data }));
          console.log('✅ Products loaded successfully');
          
          // Disable mode selection modal for direct links
          store.dispatch(setModesModal({ modesModal: false }));
        }
      }
    }
    
    // 7. Finalize initialization
    store.dispatch(setScroll({ scroll: 0 }));
    
    console.log('✅ Store initialized successfully');
    return true;
    
  } catch (error) {
    console.error('❌ Error initializing store:', error);
    store.dispatch(setStoresModal({ storesModal: true }));
    store.dispatch(setModesModal({ modesModal: false }));
    return false;
  }
};

// Fonction pour naviguer directement vers un store avec mode
export const navigateToStoreWithMode = async (
  slug,
  modeName,
  tableNumber = null
) => {
  console.log(
    "🚀 Navigating to store:",
    slug,
    "with mode:",
    modeName,
    "table:",
    tableNumber
  );

  // Construire l'URL
  const params = new URLSearchParams();
  if (modeName) params.append("mode", modeName);
  if (tableNumber) params.append("table", tableNumber);

  const url = `/${slug}${params.toString() ? "?" + params.toString() : ""}`;

  // Naviguer vers l'URL
  window.history.pushState({}, "", url);

  // Initialiser le store
  return await initializeStore(slug);
};
